import { ICoordinate } from "@ryde/shared";

export const isStringCoordinate = (latLngString: string): boolean => {
  const latLngPattern = /^\d+\.\d+,\s*\d+\.\d+$/;
  return latLngPattern.test(latLngString);
};

export const convertStringCoordinate = (
  latLngString: string,
): ICoordinate | object => {
  if (isStringCoordinate(latLngString)) {
    const [lat, lng] = latLngString.split(",").map(Number);
    const coordinate: ICoordinate = {
      lat,
      lng,
    };
    return coordinate;
  }

  return {};
};
